"use client"

import HubspotMeetingsEmbed from '@/components/HubspotMeetingsEmbed'

export default function HubspotMeetingsSection({
  meetingEmbedUrl,
  meetingUrl,
  enabled,
  lang,
}: {
  meetingEmbedUrl: string
  meetingUrl?: string
  enabled: boolean
  lang: string
}) {
  return (
    <section
      id="agenda"
      className="flex flex-col items-center w-full pb-12 mt-12"
      suppressHydrationWarning
    >
      <h2 className="mb-3 text-2xl md:text-3xl font-extrabold tracking-tight text-neutral-900 text-center">
        {lang === 'EN' ? 'Book a' : 'Agenda tu'}{' '}
        <span className="red-highlight">{lang === 'EN' ? 'Meeting' : 'Cita'}</span>
      </h2>
      <div className="h-1 w-12 bg-[#fb0009] rounded mb-4" />
      <div className="w-full p-3 bg-white border border-neutral-200 rounded-lg">
        <div className="w-full overflow-hidden rounded">
          {enabled ? (
            <HubspotMeetingsEmbed url={meetingEmbedUrl} minHeight={720} />
          ) : (
            <div className="h-[220px] w-full grid place-items-center text-sm text-neutral-500">
              {lang === 'EN' ? 'Calendar unavailable' : 'Calendario no disponible'}
            </div>
          )}
        </div>
        <div className="mt-3 text-center">
          <a href={meetingUrl || '#'} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#fb0009] hover:underline">
            {lang === 'EN' ? 'Open calendar in a new tab' : 'Abrir calendario en una nueva pestaña'}
          </a>
        </div>
      </div>
    </section>
  )
}
